<template>
	<span>
		©{{ new Date().getFullYear() }} Rently
	</span>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {store} from "../store";

    export default {
        data: () => ({
        	
		})
	}
</script>